// Module
var code = `<breadcrumbs breadcrumbs-hidden="!(\$ctrl.breadcrumbsLoaded)"></breadcrumbs>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/common/customer-breadcrumbs.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;